import React, { useState } from "react";
import { Link } from "react-router-dom";

const BASE = process.env.REACT_APP_API_URL || "https://conectalagoa.onrender.com/api";

const BENEFICIOS = [
  {
    emoji: "🎯",
    title: "Talento local de verdade",
    desc: "Candidatos que já moram na região, prontos pra começar — sem pagar caro por recrutadoras de fora ou portais genéricos que não conhecem sua cidade.",
  },
  {
    emoji: "⚡",
    title: "Menos tempo contratando",
    desc: "Nossa IA já revisa, melhora e classifica cada vaga, e ranqueia os candidatos por compatibilidade — você entra no funil só quando já tem gente boa esperando.",
  },
  {
    emoji: "📣",
    title: "Presença automática",
    desc: "Cada vaga publicada já sai no site, no Instagram e no WhatsApp sem você precisar criar arte ou postar nada manualmente.",
  },
  {
    emoji: "🧠",
    title: "Menos erro de contratação",
    desc: "O score de compatibilidade por IA cruza skills, experiência e senioridade — reduzindo a chance de contratar errado e ter que recomeçar o processo.",
  },
];

const PASSOS = [
  { n: "1", title: "Cadastre sua empresa", desc: "Leva menos de 2 minutos, sem burocracia." },
  { n: "2", title: "Publique a vaga", desc: "A IA já revisa título, descrição e palavras-chave de SEO pra atrair mais candidatos." },
  { n: "3", title: "Distribuição automática", desc: "Site, Instagram e WhatsApp recebem a vaga sem esforço nenhum da sua parte." },
  { n: "4", title: "Candidatos ranqueados chegam até você", desc: "A IA calcula compatibilidade e mostra primeiro quem mais combina com a vaga." },
  { n: "5", title: "Entreviste e contrate", desc: "Tudo pelo painel: funil, agenda de entrevistas e histórico do processo." },
];

const FUNCIONALIDADES = [
  { icon: "📋", label: "Painel completo de vagas", desc: "Criar, pausar, encerrar e editar vagas em um só lugar." },
  { icon: "⭐", label: "Banco de Talentos", desc: "Busque candidatos da região mesmo sem uma vaga aberta ainda." },
  { icon: "🗂️", label: "Funil de contratação (Kanban)", desc: "Acompanhe cada candidatura por etapa, do recebido ao contratado." },
  { icon: "🤖", label: "Score de compatibilidade por IA", desc: "Cada candidato é ranqueado automaticamente por aderência à vaga." },
  { icon: "🔍", label: "Filtros avançados", desc: "Busque por cidade, experiência mínima e habilidades específicas." },
  { icon: "💬", label: "Contato direto via WhatsApp", desc: "Fale com o candidato sem sair da plataforma." },
  { icon: "🧪", label: "Triagem automática por IA", desc: "Resumo, pontos fortes e recomendação gerados antes mesmo de você olhar o currículo." },
  { icon: "📊", label: "Indicadores de RH", desc: "Métricas de tempo de contratação, conversão e volume de candidaturas." },
  { icon: "📅", label: "Agenda de entrevistas", desc: "Marque e acompanhe entrevistas direto pelo painel." },
  { icon: "📄", label: "Relatório de contratação", desc: "Documento pronto com todo o histórico do processo seletivo." },
];

const PLANOS = [
  {
    id: "free",
    nome: "Grátis",
    preco: "R$ 0",
    periodo: "pra sempre",
    destaque: false,
    desc: "Pra conhecer a plataforma e publicar sua primeira vaga.",
    itens: [
      { ok: true,  txt: "1 vaga ativa por vez" },
      { ok: true,  txt: "Banco de Talentos (busca simples)" },
      { ok: false, txt: "Destaque da vaga no site" },
      { ok: false, txt: "Ranking de candidatos por IA" },
      { ok: false, txt: "Filtros avançados de busca" },
      { ok: false, txt: "Contato direto via WhatsApp" },
      { ok: false, txt: "Triagem automática por IA" },
    ],
    cta: "Começar grátis",
  },
  {
    id: "profissional",
    nome: "Profissional",
    preco: "R$ 149",
    periodo: "/mês",
    destaque: true,
    desc: "Pra empresas que contratam com frequência e querem agilidade.",
    itens: [
      { ok: true, txt: "Vagas ativas ilimitadas" },
      { ok: true, txt: "Banco de Talentos completo" },
      { ok: true, txt: "Destaque da vaga no site" },
      { ok: true, txt: "Ranking de candidatos por IA" },
      { ok: true, txt: "Filtros avançados de busca" },
      { ok: true, txt: "Contato direto via WhatsApp" },
      { ok: false, txt: "Triagem automática por IA" },
    ],
    cta: "Quero o Profissional",
  },
  {
    id: "premium",
    nome: "Premium",
    preco: "R$ 399",
    periodo: "/mês",
    destaque: false,
    desc: "Recrutamento no piloto automático, com IA fazendo a triagem.",
    itens: [
      { ok: true, txt: "Tudo do plano Profissional" },
      { ok: true, txt: "Triagem automática por IA" },
      { ok: true, txt: "Recomendação de candidatos por IA" },
      { ok: true, txt: "Relatório de contratação" },
      { ok: true, txt: "Suporte prioritário" },
    ],
    cta: "Quero o Premium",
  },
];

export default function ParaEmpresas() {
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", mensagem: "" });
  const [assunto, setAssunto] = useState("Consultoria de RH");
  const [enviando, setEnviando] = useState(false);
  const [status, setStatus] = useState(null); // 'ok' | 'erro' | null

  const scrollToConsultoria = (assuntoPreset) => {
    setAssunto(assuntoPreset);
    document.getElementById("pe-consultoria")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const enviar = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.mensagem) return;
    setEnviando(true);
    setStatus(null);
    try {
      const res = await fetch(`${BASE}/contato`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nome: form.nome,
          email: form.email,
          assunto,
          mensagem: `${form.mensagem}${form.telefone ? `\n\nTelefone: ${form.telefone}` : ""}`,
        }),
      });
      if (!res.ok) throw new Error();
      setStatus("ok");
      setForm({ nome: "", email: "", telefone: "", mensagem: "" });
    } catch {
      setStatus("erro");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');

        .pe-root { font-family: 'DM Sans', sans-serif; color: #1a1f36; }

        /* ── HERO ── */
        .pe-hero {
          position: relative; overflow: hidden; background: #0d1f5c;
          padding: 64px 32px 52px; display: flex; align-items: center; justify-content: center;
        }
        .pe-hero::before {
          content: ''; position: absolute; inset: 0;
          background-image: radial-gradient(rgba(255,255,255,0.07) 1px, transparent 1px);
          background-size: 32px 32px; pointer-events: none;
        }
        .pe-hero::after {
          content: ''; position: absolute; right: -120px; top: -80px; width: 500px; height: 500px;
          background: radial-gradient(circle, rgba(224,123,0,0.35) 0%, transparent 70%); pointer-events: none;
        }
        .pe-hero-inner { position: relative; z-index: 1; max-width: 880px; text-align: center; }
        .pe-hero-eyebrow {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(224,123,0,0.15); border: 1px solid rgba(224,123,0,0.3); color: #f0a040;
          font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase;
          padding: 5px 14px; border-radius: 50px; margin-bottom: 16px;
        }
        .pe-hero-eyebrow::before { content: ''; width: 6px; height: 6px; border-radius: 50%; background: #e07b00; }
        .pe-hero-title {
          font-family: 'Syne', sans-serif; font-size: clamp(1.9rem, 3.6vw, 2.6rem);
          font-weight: 700; color: white; line-height: 1.2; margin: 0 0 14px;
        }
        .pe-hero-title span { color: #e07b00; }
        .pe-hero-desc {
          font-size: 15px; line-height: 1.6; color: rgba(255,255,255,0.72);
          margin: 0 auto 22px; max-width: 500px;
        }
        .pe-hero-btns { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
        .pe-hero-cta {
          display: inline-flex; align-items: center; gap: 10px; background: #e07b00; color: white;
          font-weight: 700; font-size: 15px; padding: 14px 28px; border-radius: 10px;
          text-decoration: none; transition: all 0.2s; box-shadow: 0 8px 24px rgba(224,123,0,0.4); border: none; cursor: pointer;
          font-family: 'DM Sans', sans-serif;
        }
        .pe-hero-cta:hover { background: #c96e00; transform: translateY(-2px); }
        .pe-hero-cta-ghost {
          display: inline-flex; align-items: center; gap: 8px; background: transparent; color: white;
          font-weight: 600; font-size: 15px; padding: 14px 28px; border-radius: 10px;
          text-decoration: none; transition: all 0.2s; border: 1.5px solid rgba(255,255,255,0.3); cursor: pointer;
          font-family: 'DM Sans', sans-serif;
        }
        .pe-hero-cta-ghost:hover { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.6); }

        /* ── SECTION SHELL ── */
        .pe-section { max-width: 1080px; margin: 0 auto; padding: 52px 32px; }
        .pe-section-head { text-align: center; margin-bottom: 32px; }
        .pe-section-tag {
          display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: 2px;
          text-transform: uppercase; color: #e07b00; margin-bottom: 10px;
        }
        .pe-section-title {
          font-family: 'Syne', sans-serif; font-size: clamp(1.5rem, 2.4vw, 1.9rem);
          font-weight: 800; color: #0d1f5c; margin: 0 0 10px; line-height: 1.25;
        }
        .pe-section-sub { font-size: 14px; color: #6b7280; line-height: 1.6; max-width: 520px; margin: 0 auto; }

        /* ── BENEFÍCIOS ── */
        .pe-beneficios-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
        .pe-beneficio-card {
          background: white; border: 1px solid #e8edf8; border-radius: 14px; padding: 20px 18px;
          transition: all 0.25s; position: relative; overflow: hidden;
        }
        .pe-beneficio-card::before {
          content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
          background: linear-gradient(90deg, #1a3a8f, #e07b00); transform: scaleX(0);
          transform-origin: left; transition: transform 0.3s;
        }
        .pe-beneficio-card:hover { border-color: #c5d3f0; box-shadow: 0 8px 32px rgba(26,58,143,0.08); transform: translateY(-3px); }
        .pe-beneficio-card:hover::before { transform: scaleX(1); }
        .pe-beneficio-emoji { font-size: 1.5rem; margin-bottom: 10px; display: block; }
        .pe-beneficio-title { font-family: 'Syne', sans-serif; font-size: 14px; font-weight: 700; color: #0d1f5c; margin: 0 0 6px; }
        .pe-beneficio-desc { font-size: 12.5px; color: #6b7280; line-height: 1.55; margin: 0; }

        /* ── COMO FUNCIONA ── */
        .pe-passos-bg { background: #f8faff; border-top: 1px solid #e8edf8; border-bottom: 1px solid #e8edf8; }
        .pe-passos-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; }
        .pe-passo-card { text-align: center; padding: 0 6px; }
        .pe-passo-num {
          width: 34px; height: 34px; border-radius: 50%; margin: 0 auto 10px;
          background: linear-gradient(135deg, #1a3a8f, #e07b00); color: white;
          display: flex; align-items: center; justify-content: center;
          font-family: 'Syne', sans-serif; font-weight: 800; font-size: 14px;
        }
        .pe-passo-title { font-weight: 700; font-size: 13px; color: #0d1f5c; margin: 0 0 4px; }
        .pe-passo-desc { font-size: 12px; color: #6b7280; line-height: 1.5; margin: 0; }

        /* ── FUNCIONALIDADES ── */
        .pe-func-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
        .pe-func-item {
          display: flex; gap: 12px; align-items: flex-start; background: white;
          border: 1px solid #e8edf8; border-radius: 12px; padding: 13px 16px; transition: all 0.2s;
        }
        .pe-func-item:hover { border-color: #c5d3f0; box-shadow: 0 4px 20px rgba(26,58,143,0.06); }
        .pe-func-icon { font-size: 1.25rem; flex-shrink: 0; line-height: 1; }
        .pe-func-label { font-weight: 700; font-size: 13px; color: #0d1f5c; margin: 0 0 3px; }
        .pe-func-desc { font-size: 12px; color: #6b7280; line-height: 1.5; margin: 0; }

        /* ── PRICING ── */
        .pe-pricing-bg { background: #f8faff; border-top: 1px solid #e8edf8; border-bottom: 1px solid #e8edf8; }
        .pe-pricing-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; align-items: stretch; }
        .pe-plano-card {
          background: white; border: 1.5px solid #e8edf8; border-radius: 16px; padding: 24px 22px;
          display: flex; flex-direction: column; position: relative; transition: all 0.25s;
        }
        .pe-plano-card.destaque { border-color: #e07b00; box-shadow: 0 12px 40px rgba(224,123,0,0.18); transform: scale(1.03); }
        .pe-plano-badge {
          position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
          background: #e07b00; color: white; font-size: 10.5px; font-weight: 700;
          padding: 3px 12px; border-radius: 100px; letter-spacing: 0.05em; text-transform: uppercase;
        }
        .pe-plano-nome { font-family: 'Syne', sans-serif; font-size: 17px; font-weight: 800; color: #0d1f5c; margin: 0 0 4px; }
        .pe-plano-desc { font-size: 12px; color: #6b7280; line-height: 1.45; margin: 0 0 14px; min-height: 32px; }
        .pe-plano-preco { display: flex; align-items: baseline; gap: 4px; margin-bottom: 16px; }
        .pe-plano-preco-valor { font-family: 'Syne', sans-serif; font-size: 28px; font-weight: 800; color: #1a3a8f; }
        .pe-plano-preco-periodo { font-size: 12.5px; color: #9ca3af; }
        .pe-plano-lista { list-style: none; padding: 0; margin: 0 0 18px; flex: 1; }
        .pe-plano-item { display: flex; align-items: flex-start; gap: 8px; font-size: 12.5px; padding: 5px 0; color: #374151; }
        .pe-plano-item.off { color: #b0b7c3; }
        .pe-plano-check { flex-shrink: 0; margin-top: 1px; }
        .pe-plano-btn {
          display: block; text-align: center; padding: 11px; border-radius: 10px; font-weight: 700;
          font-size: 13px; text-decoration: none; transition: all 0.2s; border: none; cursor: pointer;
          font-family: 'DM Sans', sans-serif;
        }
        .pe-plano-btn.primary { background: #e07b00; color: white; box-shadow: 0 6px 18px rgba(224,123,0,0.35); }
        .pe-plano-btn.primary:hover { background: #c96e00; }
        .pe-plano-btn.outline { background: white; color: #1a3a8f; border: 1.5px solid #dde2f0; }
        .pe-plano-btn.outline:hover { border-color: #1a3a8f; }
        .pe-pricing-nota { text-align: center; font-size: 12px; color: #9ca3af; margin-top: 20px; }

        /* ── CONSULTORIA RH ── */
        .pe-consultoria-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; }
        .pe-consultoria-lista { list-style: none; padding: 0; margin: 16px 0 0; }
        .pe-consultoria-lista li {
          display: flex; gap: 10px; align-items: flex-start; font-size: 13.5px;
          color: #374151; padding: 6px 0; line-height: 1.45;
        }
        .pe-form { background: #f8faff; border: 1px solid #e8edf8; border-radius: 16px; padding: 24px; }
        .pe-form-label { display: block; font-size: 11.5px; font-weight: 700; color: #475569; margin: 0 0 5px; text-transform: uppercase; letter-spacing: 0.04em; }
        .pe-form-input, .pe-form-textarea {
          width: 100%; padding: 10px 13px; border-radius: 9px; border: 1px solid #dde2f0;
          font-size: 13.5px; font-family: 'DM Sans', sans-serif; outline: none; margin-bottom: 12px; box-sizing: border-box;
          transition: border-color 0.15s;
        }
        .pe-form-input:focus, .pe-form-textarea:focus { border-color: #1a3a8f; }
        .pe-form-textarea { resize: vertical; min-height: 70px; }
        .pe-form-btn {
          width: 100%; padding: 12px; border-radius: 10px; border: none; cursor: pointer;
          background: linear-gradient(135deg, #1a3a8f, #2d52c4); color: white; font-weight: 700;
          font-size: 13.5px; font-family: 'DM Sans', sans-serif; transition: opacity 0.2s;
        }
        .pe-form-btn:disabled { opacity: 0.6; cursor: default; }
        .pe-form-msg { margin-top: 12px; font-size: 12.5px; font-weight: 600; text-align: center; }
        .pe-form-msg.ok { color: #16a34a; }
        .pe-form-msg.erro { color: #dc2626; }

        /* ── CTA FINAL ── */
        .pe-cta-section {
          background: linear-gradient(135deg, #0d1f5c 0%, #1a3a8f 100%); padding: 56px 32px;
          text-align: center; position: relative; overflow: hidden;
        }
        .pe-cta-section::before {
          content: ''; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
          width: 600px; height: 300px; background: radial-gradient(ellipse, rgba(224,123,0,0.2) 0%, transparent 70%);
          pointer-events: none;
        }
        .pe-cta-inner { position: relative; z-index: 1; }
        .pe-cta-title { font-family: 'Syne', sans-serif; font-size: clamp(1.4rem, 2.6vw, 1.9rem); font-weight: 800; color: white; margin: 0 0 10px; }
        .pe-cta-sub { font-size: 14px; color: rgba(255,255,255,0.65); margin: 0 0 24px; }

        @media (max-width: 900px) {
          .pe-beneficios-grid { grid-template-columns: repeat(2, 1fr); }
          .pe-passos-grid { grid-template-columns: repeat(2, 1fr); }
          .pe-func-grid { grid-template-columns: 1fr; }
          .pe-pricing-grid { grid-template-columns: 1fr; }
          .pe-plano-card.destaque { transform: none; }
          .pe-consultoria-grid { grid-template-columns: 1fr; gap: 32px; }
        }
        @media (max-width: 600px) {
          .pe-hero { padding: 44px 20px 40px; }
          .pe-section { padding: 40px 20px; }
          .pe-beneficios-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="pe-root">

        {/* ── HERO ── */}
        <section className="pe-hero">
          <div className="pe-hero-inner">
            <div className="pe-hero-eyebrow">Para empresas de Lagoa Vermelha e região</div>
            <h1 className="pe-hero-title">
              Contrate mais rápido,<br/>
              gastando <span>menos tempo</span> com o processo
            </h1>
            <p className="pe-hero-desc">
              O Conecta Lagoa publica, distribui e ranqueia candidatos pra sua vaga automaticamente —
              você só entra pra entrevistar quem já é compatível.
            </p>
            <div className="pe-hero-btns">
              <Link to="/empresa/registro" className="pe-hero-cta">
                Cadastrar minha empresa grátis
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
              <button className="pe-hero-cta-ghost" onClick={() => scrollToConsultoria("Consultoria de RH")}>
                Falar com consultoria de RH
              </button>
            </div>
          </div>
        </section>

        {/* ── BENEFÍCIOS ── */}
        <section className="pe-section">
          <div className="pe-section-head">
            <span className="pe-section-tag">Por que o Conecta Lagoa</span>
            <h2 className="pe-section-title">O que sua empresa ganha usando a plataforma</h2>
            <p className="pe-section-sub">
              Recrutamento local, rápido e com apoio de IA — sem depender de portais genéricos
              que não conhecem a sua região.
            </p>
          </div>
          <div className="pe-beneficios-grid">
            {BENEFICIOS.map((b) => (
              <div key={b.title} className="pe-beneficio-card">
                <span className="pe-beneficio-emoji">{b.emoji}</span>
                <h3 className="pe-beneficio-title">{b.title}</h3>
                <p className="pe-beneficio-desc">{b.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── COMO FUNCIONA ── */}
        <div className="pe-passos-bg">
          <section className="pe-section">
            <div className="pe-section-head">
              <span className="pe-section-tag">Como funciona</span>
              <h2 className="pe-section-title">Do cadastro à contratação, em 5 passos</h2>
            </div>
            <div className="pe-passos-grid">
              {PASSOS.map((p) => (
                <div key={p.n} className="pe-passo-card">
                  <div className="pe-passo-num">{p.n}</div>
                  <div className="pe-passo-title">{p.title}</div>
                  <p className="pe-passo-desc">{p.desc}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* ── FUNCIONALIDADES ── */}
        <section className="pe-section">
          <div className="pe-section-head">
            <span className="pe-section-tag">Tudo incluso</span>
            <h2 className="pe-section-title">Tudo que você tem disponível</h2>
            <p className="pe-section-sub">
              Um painel completo pensado pra empresas que não têm tempo de gerenciar recrutamento manualmente.
            </p>
          </div>
          <div className="pe-func-grid">
            {FUNCIONALIDADES.map((f) => (
              <div key={f.label} className="pe-func-item">
                <span className="pe-func-icon">{f.icon}</span>
                <div>
                  <div className="pe-func-label">{f.label}</div>
                  <p className="pe-func-desc">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── PRICING ── */}
        <div className="pe-pricing-bg">
          <section className="pe-section">
            <div className="pe-section-head">
              <span className="pe-section-tag">Planos</span>
              <h2 className="pe-section-title">Escolha o pacote que faz sentido pra sua empresa</h2>
              <p className="pe-section-sub">Comece grátis e evolua conforme sua necessidade de contratação cresce.</p>
            </div>
            <div className="pe-pricing-grid">
              {PLANOS.map((plano) => (
                <div key={plano.id} className={`pe-plano-card${plano.destaque ? " destaque" : ""}`}>
                  {plano.destaque && <span className="pe-plano-badge">Mais escolhido</span>}
                  <div className="pe-plano-nome">{plano.nome}</div>
                  <p className="pe-plano-desc">{plano.desc}</p>
                  <div className="pe-plano-preco">
                    <span className="pe-plano-preco-valor">{plano.preco}</span>
                    <span className="pe-plano-preco-periodo">{plano.periodo}</span>
                  </div>
                  <ul className="pe-plano-lista">
                    {plano.itens.map((item) => (
                      <li key={item.txt} className={`pe-plano-item${item.ok ? "" : " off"}`}>
                        <span className="pe-plano-check">{item.ok ? "✅" : "—"}</span>
                        {item.txt}
                      </li>
                    ))}
                  </ul>
                  {plano.id === "free" ? (
                    <Link to="/empresa/registro" className="pe-plano-btn primary">{plano.cta}</Link>
                  ) : (
                    <button
                      className={`pe-plano-btn ${plano.destaque ? "primary" : "outline"}`}
                      onClick={() => scrollToConsultoria(`Interesse no plano ${plano.nome}`)}
                    >
                      {plano.cta}
                    </button>
                  )}
                </div>
              ))}
            </div>
            <p className="pe-pricing-nota">
              A cobrança dos planos pagos ainda é feita manualmente — fale com a gente pra ativar o seu.
            </p>
          </section>
        </div>

        {/* ── CONSULTORIA RH ── */}
        <section className="pe-section" id="pe-consultoria">
          <div className="pe-consultoria-grid">
            <div>
              <span className="pe-section-tag">Serviço especial</span>
              <h2 className="pe-section-title">Consultoria de RH sob consulta</h2>
              <p className="pe-section-sub" style={{ margin: 0 }}>
                Pra empresas que querem apoio de gente especializada, não só software.
              </p>
              <ul className="pe-consultoria-lista">
                <li>🧭 Estruturação do processo seletivo da sua empresa</li>
                <li>📝 Escrita de descrições de vaga que atraem candidatos certos</li>
                <li>🎤 Treinamento de quem entrevista na sua equipe</li>
                <li>📈 Montagem de indicadores de RH e organograma</li>
                <li>🤝 Acompanhamento pontual ou recorrente, conforme sua necessidade</li>
              </ul>
            </div>

            <form className="pe-form" onSubmit={enviar}>
              <label className="pe-form-label">Assunto</label>
              <input className="pe-form-input" value={assunto} onChange={(e) => setAssunto(e.target.value)} />

              <label className="pe-form-label">Nome</label>
              <input
                className="pe-form-input"
                value={form.nome}
                onChange={(e) => setForm((p) => ({ ...p, nome: e.target.value }))}
                placeholder="Seu nome"
                required
              />

              <label className="pe-form-label">E-mail</label>
              <input
                className="pe-form-input"
                type="email"
                value={form.email}
                onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                placeholder="voce@suaempresa.com.br"
                required
              />

              <label className="pe-form-label">Telefone (opcional)</label>
              <input
                className="pe-form-input"
                value={form.telefone}
                onChange={(e) => setForm((p) => ({ ...p, telefone: e.target.value }))}
                placeholder="(00) 00000-0000"
              />

              <label className="pe-form-label">Mensagem</label>
              <textarea
                className="pe-form-textarea"
                value={form.mensagem}
                onChange={(e) => setForm((p) => ({ ...p, mensagem: e.target.value }))}
                placeholder="Conte um pouco sobre sua empresa e o que você precisa..."
                required
              />

              <button className="pe-form-btn" type="submit" disabled={enviando}>
                {enviando ? "Enviando..." : "Enviar mensagem"}
              </button>

              {status === "ok" && <div className="pe-form-msg ok">✓ Recebemos sua mensagem! Vamos responder em breve.</div>}
              {status === "erro" && <div className="pe-form-msg erro">Não foi possível enviar agora. Tente novamente em instantes.</div>}
            </form>
          </div>
        </section>

        {/* ── CTA FINAL ── */}
        <section className="pe-cta-section">
          <div className="pe-cta-inner">
            <h2 className="pe-cta-title">Pronto pra encontrar seu próximo contratado?</h2>
            <p className="pe-cta-sub">Cadastre sua empresa grátis e publique sua primeira vaga hoje mesmo.</p>
            <Link to="/empresa/registro" className="pe-hero-cta">
              Cadastrar minha empresa
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </Link>
          </div>
        </section>

      </div>
    </>
  );
}
